<template lang="pug">
.livetv-page
  #widget.embeddedPopup
  .livetv-loader(v-if="showLoader" :class="{ 'is-error': error }")
    .livetv-loader-card
      .livetv-loader-icon
        i(:class="error ? 'fa-solid fa-circle-exclamation' : 'fa-solid fa-tv'")
        span.livetv-loader-pulse(v-if="!error")
      p.livetv-loader-text {{ loaderText }}
      .livetv-loader-spinner(v-if="!error")
        span
        span
        span
</template>
<script>
import config from "@/config";
import errors from "@/errors";
import xhr from "@/library/_xhr-game.js";

export default {
  data() {
    return {
      iframe: false,
      iframeLoaded: false,
      iframeEmbeded: false,
      url: "",
      error: "",
      expanded: false,
      loading: true
    };
  },
  computed: {
    showLoader() {
      if (this.error) {
        return true;
      }
      if (this.url && this.iframe && !this.iframeLoaded && !this.iframeEmbeded) {
        return true;
      }
      return this.loading;
    },
    loaderText() {
      if (this.error) {
        return this.error;
      }
      return this.$t("ui.loading") || "Loading live stream...";
    }
  },
  destroyed() {
    $("html").removeClass("minimal");
    $("body").removeClass("minimal");
  },
  mounted() {
    var q = this.$route.query;
    // console.log(q);
    if (q.channel == null || q.match == null || q.sports == null) {
      this.loading = false;
      this.error = "Please select a channel to watch...";
    } else if (q.channel == "1") {
      this.expanded = true;
      this.$nextTick(() => {
        setTimeout(() => {
          // console.log("mounted1", q);
          this.launchLiveTV(q.channel, q.match, q.sports, "1.1.1.1");
        }, 1000);
      });
    } else {
      this.expanded = true;
      this.getVersion(q).then(
        res => {
          this.$nextTick(() => {
            setTimeout(() => {
              // console.log("mounted2", q);
              this.launchLiveTV(q.channel, q.match, q.sports, res);
            }, 1000);
          });
        },
        err => {
          this.loading = false;
          this.error = err;
        }
      );
    }
  },
  created() {
    // $("html").addClass("minimal");
    // $("body").addClass("minimal");
  },
  methods: {
    handleIFrame() {
      this.iframeLoaded = true;
    },
    getVersion(q) {
      return new Promise((resolve, reject) => {
        this.$http.get(config.ipify1).then(
          res => {
            resolve(res.bodyText);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    clearWidget(e) {
      $("#widget").html(e);
    },
    setWidget(e) {
      $("#widget").html(e);
    },
    getDomain(url, subdomain) {
      subdomain = subdomain || false;

      url = url.replace(/(https?:\/\/)?(www.)?/i, "");

      if (!subdomain) {
        url = url.split(".");

        url = url.slice(url.length - 2).join(".");
      }

      if (url.indexOf("/") !== -1) {
        return url.split("/")[0];
      }

      return url;
    },
    tvLink(e) {
      if (config.vg1.includes(e)) {
        return config.player10Url();
      } else {
        return config.bintuUrl();
      }
    },
    launchLiveTV(ch, mc, sp, ip) {
      var args = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        channel: ch,
        match: mc,
        sports: sp,
        ip: ip,
        brand: config.brand
      };

      xhr.launchLiveTV(args).then(
        res => {
          this.loading = false;
          if (res) {
            // console.log(res);
            if (res.success == true) {
              this.url = res.data;
              this.iframe = true;

              this.iframeEmbeded = this.url.includes("<iframe");
              if (!this.iframeEmbeded) {
                this.iframeEmbeded = this.url.includes("<script");
              }
              if (!this.iframeEmbeded) {
                // not a iframe link, can be glive or self-hosted live streaming
                //
                if (ch != 1) {
                  var link = this.url + "&compact=1";
                  var html = '<iframe src="' + link + '" frameborder="0" allowfullscreen="true" scrolling="no"/>';
                  this.setWidget(html);
                  this.iframeLoaded = true;
                } else {
                  var link = this.tvLink(sp) + this.url + "&u=" + args.account_id + "&t=" + args.session_token + "&product=" + sp;
                  var html = '<iframe src="' + link + '" frameborder="0" allowfullscreen="true" scrolling="no"/>';
                  this.setWidget(html);
                  this.iframeLoaded = true;
                }
              } else {
                // is a iframe link, can be twitch, youtube or any embeded video
                //
                // var domain = this.getDomain(window.location.hostname, false);
                var kns = this.url.replace("www.example.com", window.location.hostname);
                this.setWidget(kns);
              }
            } else {
              this.loading = false;
              this.error = this.$t("error." + res.status);
            }
          }
        },
        err => {
          console.log(err);
          this.loading = false;
          this.error = this.$t("error." + err.status);
        }
      );
    }
  }
};
</script>

<style scoped>
.livetv-page {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #0a1628;
}

.livetv-loader {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: radial-gradient(circle at center, rgba(56, 92, 182, 0.18) 0%, rgba(10, 22, 40, 0.96) 70%);
}

.livetv-loader-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 220px;
  max-width: 320px;
  padding: 28px 24px 24px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(8px);
}

.livetv-loader-icon {
  position: relative;
  width: 64px;
  height: 64px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: linear-gradient(135deg, #385cb6 0%, #2e4c97 100%);
  color: #fff;
  font-size: 24px;
  box-shadow: 0 8px 24px rgba(56, 92, 182, 0.45);
}

.livetv-loader-pulse {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #df0000;
  box-shadow: 0 0 0 0 rgba(223, 0, 0, 0.6);
  animation: livetv-pulse 1.6s ease-out infinite;
}

.livetv-loader-text {
  margin: 0 0 18px;
  color: #fff;
  font-size: 15px;
  line-height: 1.4;
  text-align: center;
  font-weight: 500;
}

.livetv-loader-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 16px;
}

.livetv-loader-spinner span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #7ea0ff;
  animation: livetv-bounce 1.2s ease-in-out infinite;
}

.livetv-loader-spinner span:nth-child(2) {
  animation-delay: 0.15s;
}

.livetv-loader-spinner span:nth-child(3) {
  animation-delay: 0.3s;
}

.livetv-loader.is-error .livetv-loader-icon {
  background: linear-gradient(135deg, #c62222 0%, #8f1a1a 100%);
  box-shadow: 0 8px 24px rgba(198, 34, 34, 0.35);
}

.livetv-loader.is-error .livetv-loader-text {
  color: #ffd6d6;
}

@keyframes livetv-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(223, 0, 0, 0.6);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(223, 0, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(223, 0, 0, 0);
  }
}

@keyframes livetv-bounce {
  0%,
  80%,
  100% {
    transform: translateY(0);
    opacity: 0.45;
  }
  40% {
    transform: translateY(-8px);
    opacity: 1;
  }
}
</style>
